module.exports = __webpack_public_path__ + "img/headshot-destevez.12a15b40.png";